import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import DOMPurify from "isomorphic-dompurify";
import isValidUrl from "../../helpers/functions/isValidUrl";
const { sanitize } = DOMPurify;
export const HtmlContainer = (props) => {
    const { htmlContent, scriptContent } = props;
    useEffect(() => {
        if (scriptContent) {
            const head = document.head;
            const script = document.createElement("script");
            if (isValidUrl(scriptContent)) {
                script.src = scriptContent;
                script.async = true;
            }
            else {
                script.text = scriptContent;
            }
            head.appendChild(script);
            return () => {
                head.removeChild(script);
            };
        }
    }, []);
    return _jsx("div", { dangerouslySetInnerHTML: { __html: sanitize(htmlContent) } });
};
//# sourceMappingURL=HtmlContainer.js.map